import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import * as ConstantsStore from '../../../store/constants';
import * as AdminStore from '../../../store/admin';

import { RequirementTypeValidationHolderForm } from '../../../components/admin/requirementTypes/RequirementTypeValidationHolderForm';

export default connect(
    (state: ApplicationState) => ({
        ...AdminStore.plainActions,
    }),
    {},
)(RequirementTypeValidationHolderForm as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
